import { defineComponent as _defineComponent } from 'vue'
import FarmsTermsAndConditions from 'JS/subscriptions/shared/components/FarmsTermsAndConditions.vue';
import GlobalData from 'JS/global/window-data';
import Icon from 'Src/js/components/Icon.vue';
import LoginSideMenuContents from 'JS/components/side-menus/account-creation/components/LoginSideMenuContents.vue';
import RewardsBadgeWithColor from 'Src/js/components/RewardsBadgeWithColor.vue';
import RewardsSideMenuContents from 'JS/components/side-menus/rewards-sign-up/components/RewardsSideMenuContents.vue';
import SideMenu from 'Src/js/components/SideMenu.vue';
import SideMenuHeaderButton from 'JS/components/side-menus/SideMenuHeaderButton.vue';
import Spinner from 'JS/components/Spinner.vue';
import UiButton from 'JS/components/UiButton.vue';
import { computed } from 'vue';
import { CreateOauthAccountRequest, ICreateAccountResource, ICreateAccountResponse, LoginPages, LoginPageType } from 'JS/types/Account';
import { IJoinRewardsStep, IVerifyUserData } from 'JS/types/rewards';
import { provideServices } from 'JS/components/side-menus/composables/services';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SubscriptionLearnMoreSlideout',
  props: {
    showDrawer: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
	(event: 'close'): void;
}), expose: any, slots: any, attrs: any }) {

//Imports




provideServices();

const isLoading = ref(false);
const showNestedSideMenu = ref<'rewards' | 'login' | null>(null);
const backArrowRouter = ref<Array<IJoinRewardsStep | LoginPageType | 'main'>>([]);
const joinRewardsStep = ref<IJoinRewardsStep>();
const currLoginPage = ref<LoginPageType>();
const forceReload = ref<boolean>(false);
const cameFromSignIn = ref<boolean>(false);

//For account creation -> rewards linking
const userVerificationData = ref<IVerifyUserData>(null);
const createAccountRequest = ref<ICreateAccountResource>(null);
const createAccountResponse = ref<ICreateAccountResponse>(null);
const createOauthAccountRequest = ref<CreateOauthAccountRequest>(null);

const isRewardsMember = computed(() => {
	return GlobalData.customer?.isRewardsMember;
});

const showBackArrow = computed((): boolean => {
	return backArrowRouter.value.length != 0;
});

function determineBackArrow(prevPage: IJoinRewardsStep | LoginPageType | "clear") {
	if (prevPage === "clear") {
		if (cameFromSignIn.value) { //true when on rewards sign up after having logged in on the login sidemenu
			backArrowRouter.value = [];
		} else {
			backArrowRouter.value = ['main'];
		}
	} else {
		backArrowRouter.value.push(prevPage);
	}
}

function handleBackArrow() {
	const page = backArrowRouter.value.pop();
	if (page === 'main') {
		backArrowRouter.value = [];
		showNestedSideMenu.value = null;
	} else if (isLoginPage(page)) {
		currLoginPage.value = page as LoginPageType;
		showNestedSideMenu.value = 'login';
		joinRewardsStep.value = null;
	} else {
		joinRewardsStep.value = page as IJoinRewardsStep;
		showNestedSideMenu.value = 'rewards';
		currLoginPage.value = null;
	}
}

function isLoginPage(value: string): boolean {
	return LoginPages.hasOwnProperty(value);
}

function changeSideMenu() {
	backArrowRouter.value.push('main');

	if (GlobalData.customer) {
		joinRewardsStep.value = 'join';
		showNestedSideMenu.value = 'rewards';
	} else {
		currLoginPage.value = 'login';
		showNestedSideMenu.value = 'login';
	}
}

function handleRewardsClose() {
	if (forceReload.value) {
		window.location.reload();
		emit('close');
	} else {
		backArrowRouter.value = [];
		showNestedSideMenu.value = null;
	}
}

function reset() {
	showNestedSideMenu.value = null;
	backArrowRouter.value = [];
}

function determineClose() {
	if (forceReload.value) window.location.reload();
	emit('close');
}

function handleForceReloadEmit() {
	forceReload.value = true;
	backArrowRouter.value = [];
}

function handleSignedIn() {
	//No back button from rewards; if we show one and user goes back to FARMS then chooses 
	//'join rewards again', they will be redirected to sign in again (despite already being logged in)
	backArrowRouter.value = [];
	cameFromSignIn.value = true;
	joinRewardsStep.value = 'join';
	showNestedSideMenu.value = 'rewards';
}

function handleGoToRewards(page: IJoinRewardsStep = "join", verificationData: IVerifyUserData = null, createData: ICreateAccountResource = null, returnPage: LoginPageType = null) {
	createOauthAccountRequest.value = null;
	cameFromSignIn.value = true;

	if (page === "verification-join") {
		determineBackArrow(returnPage);
	} else if (page === "success") {
		determineBackArrow("clear");
	}
	userVerificationData.value = verificationData;
	createAccountRequest.value = createData;
	forceReload.value = true;
	joinRewardsStep.value = page;
	showNestedSideMenu.value = 'rewards';
	isLoading.value = false;
}

function handleGoToRewardsWithOauth(page: IJoinRewardsStep = "join", verificationData: IVerifyUserData = null, createOauth: CreateOauthAccountRequest = null, returnPage: LoginPageType = null) {
	createAccountRequest.value = null;
	cameFromSignIn.value = true;

	if (page === "verification-join") {
		determineBackArrow(returnPage);
	} else if (page === "success") {
		determineBackArrow("clear");
	}
	userVerificationData.value = verificationData;
	createOauthAccountRequest.value = createOauth;
	forceReload.value = true;
	joinRewardsStep.value = page;
	showNestedSideMenu.value = 'rewards';
	isLoading.value = false;
}


return { __sfc: true,emit, isLoading, showNestedSideMenu, backArrowRouter, joinRewardsStep, currLoginPage, forceReload, cameFromSignIn, userVerificationData, createAccountRequest, createAccountResponse, createOauthAccountRequest, isRewardsMember, showBackArrow, determineBackArrow, handleBackArrow, isLoginPage, changeSideMenu, handleRewardsClose, reset, determineClose, handleForceReloadEmit, handleSignedIn, handleGoToRewards, handleGoToRewardsWithOauth, FarmsTermsAndConditions, Icon, LoginSideMenuContents, RewardsBadgeWithColor, RewardsSideMenuContents, SideMenu, SideMenuHeaderButton, Spinner, UiButton }
}

})